export const PHONE_DISPLAY = "1800 836 390";
export const PHONE_TEL = "tel:1800836390";
export const TECH_EMERGENCY_URL = "https://www.techemergency.com.au/";

export const SERVICES = [
    {
        icon: "wrench",
        title: "Computer Repairs",
        description:
            "Windows desktop and laptop troubleshooting, slow computers, startup problems, crashes, software problems and general computer faults.",
    },
    {
        icon: "wifi",
        title: "Wi-Fi & Internet Problems",
        description:
            "Help with unreliable Wi-Fi, internet connections, NBN equipment, modems, routers and home Wi-Fi troubleshooting.",
    },
    {
        icon: "mail",
        title: "Email Problems",
        description:
            "Help setting up and troubleshooting email accounts, Outlook, Gmail and other common email services.",
    },
    {
        icon: "printer",
        title: "Printer Problems",
        description:
            "Printer installation, Wi-Fi printer problems, scanning problems and computer-to-printer connectivity.",
    },
    {
        icon: "monitor",
        title: "New Computer Setup",
        description:
            "Setup and configuration of new Windows computers, including transferring files, email, printers and commonly used applications.",
    },
    {
        icon: "shield",
        title: "Virus & Scam Help",
        description:
            "Help with suspicious pop-ups, malware, scam incidents and computer security concerns.",
    },
    {
        icon: "harddrive",
        title: "Data & Backup",
        description:
            "Help with computer backups, transferring files and common data recovery situations.",
    },
    {
        icon: "briefcase",
        title: "Small Business IT Support",
        description:
            "Onsite computer and technology support for local Semaphore and western-suburbs businesses.",
    },
];

export const SUBURBS = [
    "Semaphore South",
    "Semaphore Park",
    "Grange",
    "Seaton",
    "Exeter",
    "Glanville",
    "Largs Bay",
    "Largs North",
    "Peterhead",
    "Port Adelaide",
    "Birkenhead",
    "Ethelton",
    "New Port",
    "West Lakes",
    "West Lakes Shore",
    "North Haven",
    "Outer Harbour",
    "Taperoo",
];

export const WHY_CHOOSE_US = [
    "Local Adelaide business",
    "Onsite service — we come to you",
    "Home and small-business support",
    "Friendly, straightforward assistance",
    "Police-checked technician",
    "Real technician — not a national call centre",
    "Backed by Tech Emergency",
];

export const BUSINESS_SERVICES = [
    "Computer troubleshooting",
    "Microsoft 365",
    "Business email",
    "Wi-Fi and networking",
    "Printers",
    "New computers",
    "Cyber security",
    "Backup",
    "Business VoIP",
    "Ongoing IT support",
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1758686254493-7b3e49a8f325?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGhlbHBpbmclMjBzZW5pb3IlMjB3aXRoJTIwbGFwdG9wfGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=85",
    senior:
        "https://images.unsplash.com/photo-1683108339413-46e8d4a4bdeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzZW5pb3IlMjB1c2luZyUyMGxhcHRvcCUyMGF0JTIwaG9tZXxlbnwwfHx8fDE3ODY1NDQ1MTJ8MA&ixlib=rb-4.1.0&q=85",
    local: "https://images.unsplash.com/photo-1689920867303-7e3e046a41c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxhZGVsYWlkZSUyMHNlbWFwaG9yZSUyMGJlYWNofGVufDB8fHx8MTc4NjU0MzMwOHww&ixlib=rb-4.1.0&q=85",
    business:
        "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjBpdCUyMHN1cHBvcnR8ZW58MHx8fHwxNzgyNjc0NTc2fDA&ixlib=rb-4.1.0&q=85",
    tom: "/tom.jpg",
};
